import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import Loader from '../Loader/Loader';
import Header from '../Header';
import Footer from '../Footer';

function Pages() {
    const page_slug = useParams();
    const [loading, setLoading] = useState(true);
    

    const [pagecontent, setPageContent] = useState([]);

    useEffect(() =>{
      pages();
      console.log(page_slug.id);
    },[])
  
  
    const pages = async () =>{
      try {
        setLoading(true)
        let formData = new FormData();
        formData.append('page_slug', page_slug.id);
        axios.post(`${process.env.REACT_APP_API_URL}/page_detail`, formData).then((response) => {
          setLoading(false)
          console.log(response.data);
          setPageContent(response.data.data.page_content)
        })
        
      } catch (error) {
        console.log(error);
        
      }
    }
  return (
    <>
    {loading ?
      (
        <Loader loading={loading} />) : (
        <>
          <Header />
          <Container style={{marginTop:"10%"}}>
          <div style={{ color: "#fff" }} dangerouslySetInnerHTML={{ __html: pagecontent }} />
          </Container>
        
        </>
      )}
  </>
  )


}

export default Pages
